import { Injectable } from '@angular/core';
var MapsAPILoader = (function () {
    function MapsAPILoader() {
    }
    return MapsAPILoader;
}());
export { MapsAPILoader };
MapsAPILoader.decorators = [
    { type: Injectable },
];
/** @nocollapse */
MapsAPILoader.ctorParameters = function () { return []; };
//# sourceMappingURL=maps-api-loader.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/@agm/core/services/maps-api-loader/maps-api-loader.js
// module id = ../../../../@agm/core/services/maps-api-loader/maps-api-loader.js
// module chunks = 3